<template>
<!-- 新年活动 -->
  <div class="new-year-container noselect">
    <div class="img-header"></div>
    <div class="lucky-user">
      <div class="content" v-if="luckyListDouble.length !== 0"
        :style="`height:${luckyList.length * 35 * 2}px;
        animation-duration:${animationDuration}s`">
        <div class="content-text" style="height:35px;display:flex;justify-content:center" v-for="(item, index) in luckyListDouble" :key="index">
          <span>恭喜用户{{item.clientCode}}抽到{{item.prizeName}}</span>
          <!-- <span>抽到{{item.prizeName}}</span> -->
        </div>
      </div>
      <div class="content" v-if="luckyListDouble.length === 0">
        <div class="content-text" style="height:35px;display:flex;justify-content:center">还没有用户获得奖品，快来抽签吧！</div>
      </div>
    </div>
    <div class="draw-text" @click="getBestDraw()">{{drawText}}</div>
    <div class="lottery-times">
      <div>今日还有 {{totalCount || 0}} 次抽签机会</div>
    </div>
    <div class="pop-btn">
      <div class="my-gift" @click="myGift()">我的新年礼</div>
      <div v-show="!hasPopup" class="flip" @click="getChance()">
        <div class="front">
          获取更多机会
        </div>
        <div class="back">最多可获7次抽签</div>
      </div>
    </div>

    <!-- 大奖抢先看 -->
    <div class="gift-content">
      <div class="gift-header">
        <img src="../../assets/images/new-year/prize-title.png" />
      </div>
      <div class="gift-details">
        <div class="gift-row" v-for="(item, index) in giftList" :key="index">
          <div class="gift-item item-front" :class="isFlip && flipIndex.includes(index) ? 'flip-front' : ''" @click="playFlip(index)">
            <div class="gift-box">
              <div class="gift-name">
                <img :src="item.giftName" />
              </div>
              <!-- <div class="gift-desc">{{item.giftDesc}}</div> -->
              <!-- <div class="deadline" v-html="item.deadline"></div> -->
            </div>
            <div class="return-icon">
              <span>翻转</span>
            </div>
          </div>
          <div class="gift-item item-back" :class="isFlip && flipIndex.includes(index) ? 'flip-back' : ''" :key="index" @click="playFlip(index)">
            <div class="gift-img" v-show="item.giftImg" :style="{width: item.type == 'vip' ? '50%' : item.type === 'draw' ? '40%' :'30%'}">
              <img :src="item.giftImg" />
            </div>
            <div class="gift-text"
              :style="{width: item.type == 'vip' ? '50%' :item.type == 'draw' ? '60%' : '70%',
                paddingRight: item.type == 'draw' ? '10px': ''}">
              <div class="gift-title" :style="{'textAlign': item.type == 'draw' ? 'center' : 'left'}" v-html="item.giftTitle"></div>
              <div class="gift-detail" v-html="item.giftDetails"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 活动规则 -->
    <div class="draw-rules">
      <div class="rules-context">
        <p>1.活动时间：2021年1月29日-2021年2月10日；</p>
        <p>2.每个用户每日有2次免费抽签机会，做任务可获得更多机会；</p>
        <p>3.扫码任务，每日最多可获得2次抽签机会；积分兑换任务，每日最多可获得3次抽签机会；</p>
        <p>4.中奖用户可在【我的新年礼】查看，易加积分实时到账，尊贵卡将于中奖后2日内发放至卡券包，实物礼品将于春节后随未发货积分兑换订单一起寄出；</p>
        <p>5.尊贵卡可享受全单礼品9折优惠（终端产品不可用），卡片有效期至2021年12月31日，具体使用规则请在中奖后前往“我的卡券”中查看；</p>
        <p>6.本活动仅针对博世易加IAM用户，最终解释权归博世易加所有，如果疑问请咨询客服。</p>
      </div>
    </div>

    <!-- 抽奖弹窗 -->
    <newYearDrawPop ref="drawPopup" :totalCount="totalCount" :blessingUri="blessingUri" :attendInfo="attendInfo" @closePop="closePop"></newYearDrawPop>
    <!-- 新年礼 -->
    <newYearGiftPop ref="giftPopup" :userGiftList="userGiftList" @closePop="closePop"></newYearGiftPop>
    <!-- 获取更多机会 -->
    <newYearChance ref="chancePopup" :pointGainCount="pointGainCount" :scanGainCount="scanGainCount" @closePop="closePop"></newYearChance>
  </div>
</template>
<script>
import newYearDrawPop from './components/new-year-draw-pop'
import newYearGiftPop from './components/new-year-gift-pop'
import newYearChance from './components/new-year-chance'
import activityApi from '@/api/activity'
export default {
  components: {
    newYearDrawPop,
    newYearGiftPop,
    newYearChance
  },
  data () {
    return {
      luckyList: [],
      luckyListDouble: [],
      totalCount: '', // 抽签机会
      usedDrawTimes: 1, // 已抽签次数
      scanGainCount: '', // 扫码获得次数
      pointGainCount: '', // 积分获得次数
      animationDuration: '',
      userGiftList: [], // 用户获得的新年礼
      giftList: [
        { 'giftName': require('../../assets/images/new-year/vip-card.png'),
          'giftImg': require('../../assets/images/new-year/vip.png'),
          'giftTitle': '全年全单<br>打9折！',
          'type': 'vip',
          'giftDetails': '' },
        { 'giftName': require('../../assets/images/new-year/extra-point.png'),
          'giftImg': require('../../assets/images/new-year/point.png'),
          'giftTitle': '最高可得66666积分哦！',
          'giftDetails': '' },
        { 'giftName': require('../../assets/images/new-year/cup-text.png'),
          'giftImg': require('../../assets/images/new-year/cup.png'),
          'giftTitle': '幻响果汁杯<br>价值25800积分',
          'giftDetails': '多功能鲜榨果汁杯，你值得喝口更好的！' },
        { 'giftName': require('../../assets/images/new-year/u-text.png'),
          'giftImg': require('../../assets/images/new-year/bosch-u.png'),
          'giftTitle': '博世U盘<br>价值5800积分',
          'giftDetails': '内存16G，好记性不如带U盘！' },
        { 'giftName': require('../../assets/images/new-year/wash-text.png'),
          'giftImg': require('../../assets/images/new-year/wash.png'),
          'giftTitle': '免水洗手液<br>价值2990积分',
          'giftDetails': '小易陪伴<br>健康安心！' },
        { 'giftName': require('../../assets/images/new-year/lucky.png'),
          'giftImg': require('../../assets/images/new-year/qian.png'),
          'giftTitle': '新年好运<br>抽出来！',
          'type': 'draw',
          'giftDetails': '' }
      ],

      isFlip: false,
      flipIndex: [],
      blessingUri: '',
      attendInfo: {},
      hasPopup: false
    }
  },
  computed: {
    drawText () {
      if (this.totalCount === 0 && this.usedDrawTimes >= 7) {
        return '今日已无额度'
      }
      if (this.totalCount === 0 && this.usedDrawTimes < 7) {
        return '获取更多机会'
      }
      return '抽取旺签'
    }
  },
  mounted () {
    this.getDrawDtail()
    this.getDrawCount()
  },
  methods: {
    // 获取中奖信息
    getDrawDtail () {
      activityApi.getDrawDtail().then(res => {
        if (res.data.resultCode === '0') {
          this.luckyList = res.data.resultData.drawWinDetailList || ''
          this.luckyListDouble = this.luckyList.concat(this.luckyList)
          this.animationDuration = this.luckyList.length * 2
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取抽签次数
    getDrawCount () {
      activityApi.getDrawCount().then(res => {
        if (res.data.resultCode === '0') {
          let count = res.data.resultData.drawCountDetail
          this.totalCount = count.totalCount
          this.scanGainCount = count.scanQrGainCount
          this.pointGainCount = count.pointConversionGainCount
          // 默认用户抽奖次数为 2
          this.usedDrawTimes = this.scanGainCount + this.pointGainCount + 2 - this.totalCount
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 抽签
    getBestDraw () {
      if (this.drawText === '获取更多机会') {
        this.getChance()
        return
      }
      if (this.drawText === '今日已无额度') {
        return
      }
      activityApi.startDraw().then(res => {
        if (res.data.resultCode === '0') {
          // 抽签成功
          this.hasPopup = true
          this.$refs['drawPopup'].popAppear()
          this.totalCount = res.data.resultData.drawCountDetail.totalCount
          this.blessingUri = res.data.resultData.blessingUri || ''
          this.attendInfo = res.data.resultData.attendInfo || {}
          this.getDrawDtail()
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获得的新年礼
    myGift () {
      this.hasPopup = true
      this.$refs['giftPopup'].popAppear()
      activityApi.getUserDrawInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.userGiftList = res.data.resultData.oneselfDrawWinRecordList || []
        }
      }).catch(err => {
        console.log(err)
      })
    },

    getChance () {
      this.hasPopup = true
      this.$refs['chancePopup'].popAppear()
    },

    playFlip (idx) {
      const isIndex = this.flipIndex.includes(idx)
      if (isIndex) {
        this.flipIndex.forEach((item, index) => {
          if (idx === item) {
            this.flipIndex.splice(index, 1)
          }
        })
      } else {
        this.flipIndex.push(idx)
      }
      this.isFlip = true
    },
    closePop () {
      setTimeout(() => {
        this.hasPopup = false
      }, 300)
    }
  }
}
</script>
<style lang="less" scoped>
.animation-paused {
  animation-play-state: paused
}
.animation-running {
  animation-play-state: running
}
@font-face{
  font-family: 'Huawenlishu';
  src : url('../../assets/fonts/huawenlishu.ttf');
}
.new-year-container {
  padding: 410px 0px 0px 0px;
  background-image: url('../../assets/images/new-year/new-year-bg.png');
  background-size: 100%;
}
.noselect {
  user-select: none;
}
.lucky-user {
  width: 300px;
  height: 35px;
  margin: 0 auto;
  // padding: 0 20px;
  padding: 0 10px;
  overflow: hidden;
  background: rgba(0,0,0, .3);
  border-radius: 20px;
  box-sizing: border-box;
  .content {
    animation-name: rowup;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  .content-text {
    display: flex;
    justify-content: space-between;
    height: 35px;
    color: #fff;
    line-height: 35px;
    // span {
    //   width: 50%;
    // }
  }
}
@keyframes rowup {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -50%, 0);
  }
}
.pop-btn {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  .my-gift {
    width: 100px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
    background: rgba(0,0,0, .3);
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    &::before {
      content: '';
      width: 14px;
      height: 14px;
      position: relative;
      display: inline-block;
      right: 2px;
      background: url('../../assets/images/new-year/return.png');
      vertical-align: middle;
    }
  }
  .flip {
    width: 110px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
    background: rgba(0,0,0, .3);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    // animation: spin 4s linear infinite;
    animation-duration: 8s;
    animation-name: spin;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    transform-style: preserve-3d;
    transform-origin: left center;
  }
  .front,
  .back {
    position: absolute;
    width: 110px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    backface-visibility: hidden;
  }
  .front {
    transform: rotateX(0deg);
    &::after {
      content: '';
      width: 14px;
      height: 14px;
      position: relative;
      display: inline-block;
      background: url('../../assets/images/new-year/right.png');
      vertical-align: text-top;
    }
  }
  .back {
    transform: rotateX(180deg);
  }
  @keyframes spin {
    100% {
      transform: rotateX(360deg);
    }
  }
}
.draw-text {
  width: 169px;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto 0px;
  padding: 5px 20px 25px 10px;
  font-size: 22px;
  color: #7b4b07;
  font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
  background-image: url('../../assets/images/new-year/draw.png');
  background-size: 100%;
  box-sizing: border-box;
}
.lottery-times {
  display: flex;
  justify-content: center;
  color: #d22b0f;
  text-shadow: -1px 0  #ffffff, 0 1px #ffffff, 1px 0 #ffffff,0 -1px #ffffff;
}
.gift-content {
  width: 100%;
  padding: 0 10px 20px 10px;
  box-sizing: border-box;
  .gift-header {
    position: relative;
    width: 187px;
    height: 50px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
    }
  }
  .gift-details {
    width: 100%;
    // height: 450px;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
    overflow: hidden;
    .gift-row {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      width: 176px;
      height: 117px;
    }
    .gift-item {
      position: absolute;
      width: 176px;
      height: 117px;
      transition: all 1s ease-in-out 0s;
      backface-visibility: hidden;
      margin-bottom: 10px;
      .gift-box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
    .item-front {
      padding: 15px 25px 30px 20px;
      background-image: url('../../assets/images/new-year/front.png');
      background-size: 100% auto;
      z-index: 2;
      box-sizing: border-box;
      .gift-name {
        width: 100%;
      }
      img {
        width: 100%;
      }
    }
    .return-icon {
      position: absolute;
      width: 50px;
      height: 20px;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      color: #f1f1f1;
      font-size: 12px;
      line-height: 20px;
      border-radius: 10px;
      background-color: rgba(0,0,0,.3);
        span::after {
          content: '';
          width: 16px;
          height: 16px;
          position: relative;
          display: inline-block;
          bottom: 2px;
          background: url('../../assets/images/new-year/fanzhuan.png');
          background-size: 100%;
          vertical-align: middle;
      }
    }
    .item-back {
      display: flex;
      justify-content: space-between;
      position: absolute;
      padding: 5px 10px 20px 10px;
      transform: rotateY(180deg);
      background-image: url('../../assets/images/new-year/back.png');
      background-size: 100%;
      z-index: 1;
      box-sizing: border-box;
      .gift-img {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        width: 100%;
      }
      .gift-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0px 5px;
        color: #fff;
      }
      .gift-title {
        font-size: 14px;
      }
      .gift-detail {
        font-size: 12px;
        margin-top: 5px;
        line-height: 1.3;
      }
    }
    .flip-front {
      transform: rotateY(180deg);
    }
    .flip-back {
      transform: rotateY(0deg);
    }

  }
}
.draw-rules {
  width: 348px;
  height: 363px;
  margin: 0 auto;
  background-image: url('../../assets/images/new-year/rules-box.png');
  background-size: 100% auto;
  .rules-context {
    width: 85%;
    padding-top: 48px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 13px;
    line-height: 1.5;
  }
}
</style>
